import type { Components, Theme } from '@mui/material/styles';

export const MuiTypography: Components<Theme>['MuiTypography'] = {
  styleOverrides: {
    caption: { color: 'var(--mui-palette-text-secondary)' },
  },
};
